var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"article article_html",style:('padding:' + _vm.options.data.pageCss.page_css_padding + 
  ';margin:' + _vm.options.data.pageCss.page_css_margin + 
  ';border-radius:' + _vm.options.data.pageCss.page_css_radius + 
  'px;background-color:' + _vm.options.data.pageCss.textBgc+';'+_vm.options.data.pageCss.myCss),domProps:{"innerHTML":_vm._s(_vm.options.data.desc||'请在右侧编辑文本')}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }